import axios from "axios";
import { isPublicPath } from "../lib/publicPaths";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE_URL = `${BACKEND_URL}/api`;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  timeout: 15000, // 15s timeout — prevents infinite hangs on weak signal
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("ggr_auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // CRITICAL: Only redirect on real 401 auth failure, NOT network errors
    if (error?.response?.status === 401) {
      localStorage.removeItem("ggr_auth_token");
      localStorage.removeItem("ggr_auth_user");
      if (!isPublicPath(window.location.pathname)) {
        window.location.href = "/auth";
      }
    }
    return Promise.reject(error);
  }
);

// Check if error is a network/connectivity issue vs real server error
export function isNetworkError(error) {
  if (!error) return false;
  // No response at all = network issue
  if (!error.response) return true;
  // Request was aborted/timed out
  if (error.code === "ECONNABORTED" || error.code === "ERR_NETWORK") return true;
  // 502/503/504 = server unreachable (could be network)
  if ([502, 503, 504].includes(error.response?.status)) return true;
  return false;
}

export const getApiErrorMessage = (error, fallback = "Something went wrong.") => {
  if (isNetworkError(error)) {
    return "Internet signal is weak. Please try again in a moment.";
  }
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    return detail[0]?.msg || fallback;
  }
  return fallback;
};

export default apiClient;
